export default __webpack_public_path__ + "static/buildings-img-4c624464e136c026afdce4f51d06e848.jpg";